import React, { Component } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import Header from "../Layouts/Header";
import MenuSidebar from "../Layouts/MenuSidebar";
import $ from "jquery";
import Select from "react-select";
import { lang } from "../Helpers/lang";
import {
  PageTitle,
  CheckAuth,
  scrollToTopValidate,
  scrollToTop,
} from "../Helpers/SettingHelper";
import { apiUrl, mediaUrl, assetUrl } from "../Config/Config";
import axios from "axios";
import { ShadowPicker } from "react-shadow-picker";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { computeFilterFromHex } from '../Helpers/cssFilterSolver';

const withRouter = (WrappedComponent) => (props) => {
  const params = useParams();
  const navigate = useNavigate();
  // etc... other react-router-dom v6 hooks

  return (
    <WrappedComponent
      {...props}
      params={params}
      navigate={navigate}
      // etc...
    />
  );
};

class Edit extends Component {
  fileObj = [];
  fileArray = [];
  imageArray = [];

  constructor(props) {
    CheckAuth();
    super(props);
    const themeID =
      typeof props.params.ID === "undefined" ? "" : props.params.ID;
    this.state = {
      settingsNotesPopup: false,
      statusmessage: "",
      c_theme_id: themeID,
      title: "",

      status: "active",
      selectedFile: null,
      Loading: false,
      LoadingCloneBtn: false,
      selectedvalue: "",
      selectedOption: { value: "active", label: "Active" },
      selectedFileCount: 0,

      shadow: "",
      shadows: {
        shadowPluginOpenButton: "inset 10px 0px 10px 0px #b7b7b785",
        shadowPluginOpenButtonInset: "inset 10px 0px 10px 0px #b7b7b785",
        largeButton: "0 4px 18px 0 #0404052e",
        shadowButtonInset: "inset 5px 0px 5px 0px #3434372b",
        dashboardShadowGrid: "0 10px 21px 0 #0000001c",
        shadowDashboardGridInset: "inset 5px 0px 5px 0px #3434372b",
        dashboardShadowList: "0 21px 21px 0 #0000001c",
        shadowDashboardListInset: "inset 5px 0px 5px 0px #3434372b",
        dropdownmenu: "0px 3px 21px 0px #9f99995c",
        shadowDropdownMenuInset: "inset 5px 0px 5px 0px #3434372b",
        shadowSearchDropdown: "-2px 10px 15px #3434375e",
        shadowSearchDropdownInset: "inset 5px 0px 5px 0px #3434372b",
        shadowMapPopup: "-2px 10px 15px #3434375e",
        shadowMapPopupInset: "inset 5px 0px 5px 0px #3434372b",
        shadowTopPopup: "1px 0px #0000000c",
        shadowTopPopupInset: "1px 0px #0000000c",
        shadowLeftSidebar: "-2px 10px 15px #3434375e",
        shadowLeftSidebarInset: "inset 5px 0px 5px 0px #3434372b",
        shadowRightSidebar: "-2px 10px 15px #3434375e",
        shadowRightSidebarInset: "inset 5px 0px 5px 0px #3434372b",
        shadowAISidebar: "1px 0px #0000000c",
        shadowAISidebarInset: "inset 5px 0px 5px 0px #3434372b",
        shadowMainAITextarea: "0px 3px 21px 0px #9f99995c",
        shadowMainAITextareaInset: "inset 5px 0px 5px 0px #3434372b",
        shadowFormGroup: "0px 3px 21px 0px #9f99995c",
        shadowFormGroupInset: "inset 5px 0px 5px 0px #3434372b",
        shadowInput: "inset 5px 0px 5px 0px #3434372b",
        shadowText: "0 7px 10px -7px #04040422c",
        shadowListRow: "1px 0px #0000000c",
        shadowTableRow: "1px 0px #0000000c",
        shadowVehicleList: "1px 0px #0000000c",
        shadowVehicleListInset: "inset 5px 0px 5px 0px #3434372b",

        pluginShadow: "0px 24px 34px #0404052e",
        // sideMenu:"-2px 10px 15px #3434375e",
        // pluginInset: "5px 0px 15px 0 #3434372b",
        // smallButton: '0 18px 21px 0 #000',
        textarea: "0 7px 10px -7px #04040422",
        pluginInsideLeftShadow: "15px 0 20px -10px #9898983d",
        pluginInsideRightShadow: "-15px 0 20px -10px #9898983d",
        pluginInsideTopShadow: "0 15px 20px -10px #9898983d",
        pluginInsideBottomShadow: "0 -15px 20px -10px #9898983d",
        shortcutMenu: "0px 3px 21px 0px #9f99995c",
        shortcutMenuInset: "0px 3px 21px 0px #9f99995c",
        // sidePopup: '0 18px 21px 0 #000',

        shadowVehicleListDefault: "0 7px 10px -7px #04040422",
        shadowVehicleListDefaultInset: "inset 5px 0px 5px 0px #3434372b", 
        
        shadowVehicleListSelection: "0 7px 10px -7px #04040422",
        shadowVehicleListSelectionInset: "inset 5px 0px 5px 0px #3434372b", 
        
        shadowTabCarouselDefault: "0 7px 10px -7px #04040422",
        shadowTabCarouselDefaultInset: "inset 5px 0px 5px 0px #3434372b",  
        
        shadowTabCarouselSelection: "0 7px 10px -7px #04040422",
        shadowTabCarouselSelectionInset: "inset 5px 0px 5px 0px #3434372b", 
        
        shadowVehicleDashboardDefault: "0 7px 10px -7px #04040422",
        shadowVehicleDashboardDefaultInset: "inset 5px 0px 5px 0px #3434372b", 
        
        shadowVehicleDashboardSelection: "0 7px 10px -7px #04040422",
        shadowVehicleDashboardSelectionInset: "inset 5px 0px 5px 0px #3434372b",
      },
      activeShadowType: "largeButton",

      line_height: "",
      pluginRadius: "",
      dropdownRadius: "",
      inputRadius: "",
      textareaRadius: "",
      dashboardGridRadius: "",
      dashboardListRadius: "",
      listRowRadius: "",
      mapPopupRadius: "",
      formGroupRadius: "",
      mainAITextareaRadius: "",
      topPopupRadius: "10",
      ai_side_menu_width: "",
      st_aisidebar_collapsed_width: "",
      st_aisidebar_profile_icon_width: "",
      st_aisidebar_icon_width: "",

      fontDetails: [],
      fonttype: [],
      selectedFont: "",
      selectedFontVariant: "",
      st_varient_id: [],
      formAction: "edit", // default

      settingsNotesPopup: false,
      infoSliderName: "",
      showClonePopup: false,
      cloneTitle: "",
      ad_imagew_unit: "px",
      mem_imagew_unit: "px",
      adp_imagew_unit: "px",
      adspimageheight: "",
      adspimagewidth: "",
      adspimageradius: "",
      membershipimageheight: "",
      membershipimagewidth: "",
      adsimageradius: "",
      membershipimageradius: "",
      invite_imagew_unit: "px",
      inviteimageheight: "",
      inviteimagewidth: "",
      inviteimageradius: "",
      crcard_imagew_unit:"px",
			crcardimagewidth:"",
			crcardimageheight:"",
			crcardimageradius:"",
			ins_imagew_unit:"px",
			insimagewidth:"",
			insimageradius:"",
			insimageheight:""
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputPopupChange = this.handleInputPopupChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    //console.log(this.state.c_company_id+"-test");
  }

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
    this.setState({ selectedvalue: selectedOption.value });
  };
  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }
  handleInputPopupChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    document.title = PageTitle("Theme Edit");
    this.newDataloader();

    var admin_id = localStorage.getItem("admin_id");
    axios.get(apiUrl + "font/getfont_name?admin_id=" + admin_id).then((res) => {
      if (res.data.status == "success") {
        this.setState({
          fonttype: res.data.fontlist,
        });
      }
    });
  }
  // preloadFontVariants = async (fontValue, idx) => {
  // 	try {
  // 	  // Find label from fonttype list
  // 	  const selectedFont = this.state.fonttype.find(f => f.value == fontValue);
  // 	  const fontLabel = selectedFont ? selectedFont.label : "";

  // 	  const response = await axios.get(`${apiUrl}font/getvarientlistdetail`, {
  // 		params: {
  // 		  id: fontValue,
  // 		  name: fontLabel,
  // 		},
  // 	  });

  // 	  if (response.data.variants) {
  // 		let fontDetails = [...this.state.fontDetails];
  // 		fontDetails[idx] = {
  // 		  ...fontDetails[idx],
  // 		  variants: response.data.variants,
  // 		};
  // 		this.setState({ fontDetails }, () => {
  // 			this.state.fontDetails.forEach((font, idx1) => {
  // 				this.varientField(font.font_id, font.fontFamily, font.FontType,idx1,font,font.font_id);
  // 			});
  // 		});
  // 	  }
  // 	} catch (error) {
  // 	  console.error("Error preloading font variants:", error);
  // 	}
  // };
  preloadFontVariants = async (fontValue, idx) => {
    try {
      const selectedFont = this.state.fonttype.find(
        (f) => f.value === fontValue,
      );
      const fontLabel = selectedFont ? selectedFont.label : "";

      const response = await axios.get(`${apiUrl}font/getvarientlistdetail`, {
        params: { id: fontValue, name: fontLabel },
      });

      if (response.data?.variants) {
        let fontDetails = [...this.state.fontDetails];

        if (!fontDetails[idx]) {
          fontDetails[idx] = {};
        }

        fontDetails[idx] = {
          ...fontDetails[idx],
          variants: response.data.variants,
        };

        this.setState({ fontDetails }, () => {
          fontDetails.forEach((font, idx1) => {
            if (font) {
              this.varientField(
                font.font_id || "",
                font.fontFamily || "",
                font.fontType || "",
                idx1,
                font,
                font.font_id || "",
              );
            }
          });
        });
      }
    } catch (error) {
      console.error("Error preloading font variants:", error);
    }
  };

  newDataloader = (r = null) => {
    axios
      .get(apiUrl + "thememanagement/listdetail?id=" + this.state.c_theme_id)
      .then((res) => {
        if (res.data.status === "success") {
          const formdata = res.data.themelist;
          if (formdata.status === "A") {
            this.setState({
              selectedOption: { value: "active", label: "Active" },
            });
          } else {
            this.setState({
              selectedOption: { value: "inactive", label: "Inactive" },
            });
          }
          console.log(formdata, "formdata");
          this.setState({
            title: formdata.title,
            line_height: formdata.lineHeight,
          
            adsimageheight: formdata.adsimageheight,
            adsimagewidth: formdata.adsimagewidth,
            membershipimageheight: formdata.membershipimageheight==0 ?"":formdata.membershipimageheight,
            membershipimagewidth: formdata.membershipimagewidth==0 ?"" : formdata.membershipimagewidth,
            membershipimageradius: formdata.membershipimageradius == 0 ?"":formdata.membershipimageradius,
            ad_imagew_unit: formdata.ad_imagew_unit==null?"px":formdata.ad_imagew_unit,
            mem_imagew_unit: formdata.mem_imagew_unit==null?"px":formdata.mem_imagew_unit,
            adp_imagew_unit: formdata.adp_imagew_unit==null?"px":formdata.adp_imagew_unit,
            adspimageheight: formdata.adspimageheight==0 ? "":formdata.adspimageheight,
            adspimagewidth: formdata.adspimagewidth==0? '': formdata.adspimagewidth,
            adspimageradius: formdata.adspimageradius==0? '':formdata.adspimageradius,
            adsimageradius: formdata.adsimageradius==0 ? '':formdata.adsimageradius,
            invite_imagew_unit: formdata.invite_imagew_unit==null?"px":formdata.invite_imagew_unit,
            inviteimageheight: formdata.inviteimageheight==0 ? "":formdata.inviteimageheight,
            inviteimagewidth: formdata.inviteimagewidth==0 ? "":formdata.inviteimagewidth,
            inviteimageradius: formdata.inviteimageradius==0 ? "":formdata.inviteimageradius,
            crcard_imagew_unit:formdata.crcard_imagew_unit==null?"px":formdata.crcard_imagew_unit,
            crcardimagewidth:formdata.crcardimagewidth==0 ? "":formdata.crcardimagewidth,
            crcardimageheight:formdata.crcardimageheight==0 ? "":formdata.crcardimageheight,
            crcardimageradius:formdata.crcardimageradius==0 ? "":formdata.crcardimageradius,
            ins_imagew_unit:formdata.ins_imagew_unit==null?"px":formdata.ins_imagew_unit,
            insimagewidth:formdata.insimagewidth==0 ? "":formdata.insimagewidth,
            insimageradius:formdata.insimageradius==0 ? "":formdata.insimageradius,
            insimageheight:formdata.insimageheight==0 ? "":formdata.insimageheight,
            pluginRadius: formdata.st_plugin_radius,
            dropdownRadius: formdata.st_dropdown_menu_radius,
            inputRadius: formdata.inputRadius,
            textareaRadius: formdata.textareaRadius,
            dashboardGridRadius: formdata.dashboardGridRadius,
            dashboardListRadius: formdata.dashboardListRadius,
            listRowRadius: formdata.listRowRadius,
            mapPopupRadius: formdata.mapPopupRadius,
            formGroupRadius: formdata.formGroupRadius,
            mainAITextareaRadius: formdata.mainAITextareaRadius,
            topPopupRadius: formdata.topPopupRadius,
            ai_side_menu_width: formdata.ai_side_menu_width,
            st_aisidebar_icon_width: formdata.st_aisidebar_icon_width,
            st_aisidebar_collapsed_width: formdata.st_aisidebar_collapsed_width,
            st_aisidebar_profile_icon_width:
              formdata.st_aisidebar_profile_icon_width,
          });

          const shadowRecord = res.data.themeShadowRecord;
          const newShadows = {
            shadowPluginOpenButton: shadowRecord.shadowPluginOpenButton,
            shadowPluginOpenButtonInset:
              shadowRecord.shadowPluginOpenButtonInset,
            largeButton: shadowRecord.button_shadow,
            shadowButtonInset: shadowRecord.shadowButtonInset,
            dashboardShadowGrid: shadowRecord.dashboard_shadow_grid,
            shadowDashboardGridInset: shadowRecord.shadowDashboardGridInset,
            dashboardShadowList: shadowRecord.dashboard_shadow_list,
            shadowDashboardListInset: shadowRecord.shadowDashboardListInset,
            dropdownmenu: shadowRecord.dropdown_menu,
            shadowDropdownMenuInset: shadowRecord.shadowDropdownMenuInset,
            shadowSearchDropdown: shadowRecord.shadowSearchDropdown,
            shadowSearchDropdownInset: shadowRecord.shadowSearchDropdownInset,
            shadowMapPopup: shadowRecord.shadowMapPopup,
            shadowMapPopupInset: shadowRecord.shadowMapPopupInset,
            shadowTopPopup: shadowRecord.shadowTopPopup,
            shadowTopPopupInset: shadowRecord.shadowTopPopupInset,
            shadowLeftSidebar: shadowRecord.shadowLeftSidebar,
            shadowLeftSidebarInset: shadowRecord.shadowLeftSidebarInset,
            shadowRightSidebar: shadowRecord.shadowRightSidebar,
            shadowRightSidebarInset: shadowRecord.shadowRightSidebarInset,
            shadowAISidebar: shadowRecord.shadowAISidebar,
            shadowAISidebarInset: shadowRecord.shadowAISidebarInset,
            shadowMainAITextarea: shadowRecord.shadowMainAITextarea,
            shadowMainAITextareaInset: shadowRecord.shadowMainAITextareaInset,
            shadowFormGroup: shadowRecord.shadowFormGroup,
            shadowFormGroupInset: shadowRecord.shadowFormGroupInset,
            shadowInput: shadowRecord.shadowInput,
            shadowText: shadowRecord.shadowText,
            shadowListRow: shadowRecord.shadowListRow,
            shadowTableRow: shadowRecord.shadowTableRow,
            shadowVehicleList: shadowRecord.shadowVehicleList, 
            shadowVehicleListInset: shadowRecord.shadowVehicleListInset, 
            pluginShadow: shadowRecord.plugin_shadow,
            //   pluginInset: shadowRecord.pluginInset_shadow,
            textarea: shadowRecord.textarea_shadow,
            pluginInsideLeftShadow: shadowRecord.pluginInsideLeftShadow,
            pluginInsideRightShadow: shadowRecord.pluginInsideRightShadow,
            pluginInsideTopShadow: shadowRecord.pluginInsideTopShadow,
            pluginInsideBottomShadow: shadowRecord.pluginInsideBottomShadow,
            shortcutMenu: shadowRecord.shortcut_shadow,
            shortcutMenuInset: shadowRecord.shortcutMenuInset,
            // smallButton: shadowRecord.button_shadow,
            // sidePopup: shadowRecord.sidemenu_shadow,

            shadowVehicleListDefault: shadowRecord.shadowVehicleListDefault,
            shadowVehicleListDefaultInset: shadowRecord.shadowVehicleListDefaultInset, 
            
            shadowVehicleListSelection: shadowRecord.shadowVehicleListSelection,
            shadowVehicleListSelectionInset: shadowRecord.shadowVehicleListSelectionInset, 
            
            shadowTabCarouselDefault: shadowRecord.shadowTabCarouselDefault,
            shadowTabCarouselDefaultInset: shadowRecord.shadowTabCarouselDefaultInset,  
            
            shadowTabCarouselSelection: shadowRecord.shadowTabCarouselSelection,
            shadowTabCarouselSelectionInset: shadowRecord.shadowTabCarouselSelectionInset, 
            
            shadowVehicleDashboardDefault: shadowRecord.shadowVehicleDashboardDefault,
            shadowVehicleDashboardDefaultInset: shadowRecord.shadowVehicleDashboardDefaultInset, 
            
            shadowVehicleDashboardSelection: shadowRecord.shadowVehicleDashboardSelection,
            shadowVehicleDashboardSelectionInset: shadowRecord.shadowVehicleDashboardSelectionInset,
          };
          this.setState({ shadows: newShadows });

          if (res.data.themeFontRecord.length > 0) {
            this.setState({ fontDetails: res.data.themeFontRecord }, () => {
              // 🔹 After setting fontDetails, preload variants
              this.state.fontDetails.forEach((font, idx) => {
                if (font.font_id) {
                  this.preloadFontVariants(font.font_id, idx);
                }
              });
            });
          } else {
            this.setState({
              fontDetails: [
                {
                  index: Math.random(),
                  FontType: "",
                  FontSize: "",
                  FontWeight: "",
                  letterSpacing: "",
                  lineHeight: "",
                  TopSpace: "",
                  BottomSpace: "",
                  radius: "",
                  varient_id: "",
                },
              ],
            });
          }
        }
      });
  };

  handleFormSubmit = () => {
    if (this.validateForm()) {
      const formPayload = this.state;
      var qs = require("qs");
      var status = "";
      if (formPayload.selectedvalue === "" && formPayload.selectedvalue !== 0) {
        status = formPayload.selectedOption.value;
      } else {
        status = formPayload.selectedvalue;
      }
      var postObject = {
        admin_id: localStorage.getItem("admin_id"),
        //theme_id : formPayload.c_theme_id,
        title: formPayload.cloneTitle
          ? formPayload.cloneTitle
          : formPayload.title,
        line_height: formPayload.line_height,
				ad_imagew_unit: formPayload.ad_imagew_unit,
				mem_imagew_unit: formPayload.mem_imagew_unit,
				adp_imagew_unit: formPayload.adp_imagew_unit,
				adspimageheight: formPayload.adspimageheight,
				adspimagewidth: formPayload.adspimagewidth,
				adspimageradius: formPayload.adspimageradius,
        adsimageheight: formPayload.adsimageheight,
        adsimagewidth: formPayload.adsimagewidth,
        membershipimageheight: formPayload.membershipimageheight,
        membershipimagewidth: formPayload.membershipimagewidth,
        adsimageradius: formPayload.adsimageradius,
        invite_imagew_unit: formPayload.invite_imagew_unit,
        inviteimageheight:formPayload.inviteimageheight,
        inviteimagewidth: formPayload.inviteimagewidth,
        inviteimageradius: formPayload.inviteimageradius,
        crcard_imagew_unit:formPayload.crcard_imagew_unit,
				crcardimagewidth:formPayload.crcardimagewidth,
				crcardimageheight:formPayload.crcardimageheight,
				crcardimageradius:formPayload.crcardimageradius,
				ins_imagew_unit:formPayload.ins_imagew_unit,
				insimagewidth:formPayload.insimagewidth,
				insimageradius:formPayload.insimageradius,
				insimageheight:formPayload.insimageheight,


        membershipimageradius: formPayload.membershipimageradius,
        pluginRadius: formPayload.pluginRadius,
        dropdownRadius: formPayload.dropdownRadius,
        inputRadius: formPayload.inputRadius,
        textareaRadius: formPayload.textareaRadius,
        dashboardGridRadius: formPayload.dashboardGridRadius,
        dashboardListRadius: formPayload.dashboardListRadius,
        listRowRadius: formPayload.listRowRadius,
        mapPopupRadius: formPayload.mapPopupRadius,
        formGroupRadius: formPayload.formGroupRadius,
        mainAITextareaRadius: formPayload.mainAITextareaRadius,
        topPopupRadius: formPayload.topPopupRadius,
        ai_side_menu_width: formPayload.ai_side_menu_width,
        st_aisidebar_collapsed_width: formPayload.st_aisidebar_collapsed_width,
        st_aisidebar_icon_width: formPayload.st_aisidebar_icon_width,
        st_aisidebar_profile_icon_width:
          formPayload.st_aisidebar_profile_icon_width,
        fontDetails: JSON.stringify(formPayload.fontDetails),
        shadow: JSON.stringify(this.state.shadows),
        status: status,
      };
      // Only add theme_id if editing
      if (this.state.formAction === "edit") {
        postObject.theme_id = formPayload.c_theme_id;
        this.setState({ Loading: true });
      } else {
        this.setState({ LoadingCloneBtn: true });
      }

      let formData = new FormData();

      for (let k in postObject) {
        formData.append(k, postObject[k]);
      }
      //var filesdata = this.state.font_file;

      // for (var i in filesdata) {
      //  formData.append('font_file[]',filesdata[i])
      // }
      // Choose endpoint
      let endpoint =
        this.state.formAction === "clone"
          ? apiUrl + "thememanagement/add"
          : apiUrl + "thememanagement/edit";
      //axios.post(apiUrl+"thememanagement/edit",qs.stringify(postObject)).then(res => {
      //axios.post(apiUrl+"thememanagement/edit",formData ).then(res => {
      axios.post(endpoint, formData).then((res) => {
        if (res.data.status === "success") {
          this.setState({ Loading: false, LoadingCloneBtn: false });
          this.setState({ showClonePopup: false });
          $(".success_message").html(
            '<div class="status_sucess"><h3>' +
              res.data.message +
              "</h3></div>",
          );

          scrollToTop();
          setTimeout(
            function () {
              $(".success_message").html("");
              this.props.navigate("/theme");
            }.bind(this),
            6000,
          );
        } else {
          this.setState({ Loading: false, LoadingCloneBtn: false });
          this.setState({ showClonePopup: false });
          $(".success_message").html(
            '<div class="status_sucess"><h3>' +
              res.data.message +
              "</h3></div>",
          );

          scrollToTop();
          setTimeout(
            function () {
              $(".success_message").html("");
            }.bind(this),
            3000,
          );
        }
      });
    }
  };

  validateForm() {
    const {
      title,
      fontDetails,
      ai_side_menu_width,
      st_aisidebar_icon_width,
      st_aisidebar_collapsed_width,
      st_aisidebar_profile_icon_width,
      formAction,
      cloneTitle,
    } = this.state;

    let errors = 0;

    if (formAction === "clone") {
      if (!cloneTitle) {
        errors++;
        $(".errorcloneTitle").html(
          '<span class="errorspan">Please fill the field</span>',
        );
      } else if (cloneTitle) {
        $(".errorcloneTitle").html("");
      }
    }

    if (!title) {
      errors++;
      $(".errortitle").html(
        '<span class="errorspan">Please fill the field</span>',
      );
    } else if (title) {
      $(".errortitle").html("");
    }

    if (!ai_side_menu_width) {
      errors++;
      $(".errorsai_side_menu_width").html(
        '<span class="errorspan">Please fill the field</span>',
      );
    } else if (ai_side_menu_width) {
      $(".errorsai_side_menu_width").html("");
    }
    if (!st_aisidebar_icon_width) {
      errors++;
      $(".errorsst_aisidebar_icon_width").html(
        '<span class="errorspan">Please fill the field</span>',
      );
    } else if (st_aisidebar_icon_width) {
      $(".errorsst_aisidebar_icon_width").html("");
    }
    if (!st_aisidebar_collapsed_width) {
      errors++;
      $(".errorsst_aisidebar_collapsed_width").html(
        '<span class="errorspan">Please fill the field</span>',
      );
    } else if (st_aisidebar_collapsed_width) {
      $(".errorsst_aisidebar_collapsed_width").html("");
    }
    if (!st_aisidebar_profile_icon_width) {
      errors++;
      $(".errorsst_aisidebar_profile_icon_width").html(
        '<span class="errorspan">Please fill the field</span>',
      );
    } else if (st_aisidebar_profile_icon_width) {
      $(".errorsst_aisidebar_profile_icon_width").html("");
    }

    // Font details validation
    fontDetails.forEach((font, idx) => {
      // Reset previous errors
      $(`.errorfile${idx}`).html("");
      $(`.fontVariantError${idx}`).html("");
      $(`.fontFamilyError${idx}`).html("");
      $(`.fontSizeError${idx}`).html("");
      $(`.letterSpacingError${idx}`).html("");
      $(`.topSpaceError${idx}`).html("");
      $(`.bottomSpaceError${idx}`).html("");
      $(`.radiusError${idx}`).html("");

      if (!font.font_id || font.font_id === "") {
        errors++;
        $(`.fontFamilyError${idx}`).html(
          '<span class="errorspan">Select a font family</span>',
        );
      }
      if (!font.fontWeight || font.fontWeight === "") {
        errors++;
        $(`.fontVariantError${idx}`).html(
          '<span class="errorspan">Select a font variant</span>',
        );
      }
      if (!font.fontSize || isNaN(font.fontSize)) {
        errors++;
        $(`.fontSizeError${idx}`).html(
          '<span class="errorspan">Enter valid font size</span>',
        );
      }
      if (font.letterSpacing === "" || isNaN(font.letterSpacing)) {
        errors++;
        $(`.letterSpacingError${idx}`).html(
          '<span class="errorspan">Enter valid letter spacing</span>',
        );
      }

      if (
        ["smallbutton", "largebutton", "pluginOpenButton"].includes(
          font.FontType,
        )
      ) {
        if (!font.topSpace || isNaN(font.topSpace)) {
          errors++;
          $(`.topSpaceError${idx}`).html(
            '<span class="errorspan">Enter valid top space</span>',
          );
        }
        if (!font.bottomSpace || isNaN(font.bottomSpace)) {
          errors++;
          $(`.bottomSpaceError${idx}`).html(
            '<span class="errorspan">Enter valid bottom space</span>',
          );
        }
        if (!font.radius || isNaN(font.radius)) {
          errors++;
          $(`.radiusError${idx}`).html(
            '<span class="errorspan">Enter valid radius</span>',
          );
        }
      }
    });

    if (errors > 0) {
      setTimeout(function () {
        scrollToTopValidate();
      }, 100);
      return false;
    } else {
      return true;
    }
  }

  /**Shadow start */
  handleSubmit = () => {
    const popup = document.querySelector(".input-popup-action");
    if (popup) {
      popup.classList.remove("show");
    }
  };

  confirmPopup = (type) => {
    this.setState({ activeShadowType: type });
    $(".input-popup-action").addClass("show");
  };
  handleShadowChange = (value) => {
    console.log(value,"handleShadowChange");
    this.setState((prevState) => ({
      shadows: {
        ...prevState.shadows,
        [this.state.activeShadowType]: value,
      },
    }));
  };

  handleCancel = () => {
    const popup = document.querySelector(".input-popup-action");
    if (popup) {
      popup.classList.remove("show");
    }
  };

  handleSettingsNotesPopup = () => {
    this.setState((prevState) => ({
      settingsNotesPopup: !prevState.settingsNotesPopup,
    }));
  };

  labelFor = (key) => {
    const labels = {
      shadowPluginOpenButton: "Plugin Open Button Shadow",
      shadowPluginOpenButtonInset: "Plugin Open Inside Button Shadow",
      largeButton: "Button Shadow",
      shadowButtonInset: "Button Inside Shadow",
      dashboardShadowGrid: "Dashboard Grid Shadow",
      shadowDashboardGridInset: "Dashboard Grid Inside Shadow",
      dashboardShadowList: "Dashboard List Shadow",
      shadowDashboardListInset: "Dashboard List Inside Shadow",
      dropdownmenu:
        "Dropdown Menu Shadow (Bell notification, Address dropdown, Group menu in listing screen, Prfile dropdown, Chat window emojis dropdown)",
      shadowDropdownMenuInset:
        "Dropdown Menu Inside Shadow (Bell notification, Address dropdown, Group menu in listing screen, Prfile dropdown, Chat window emojis dropdown)",
      shadowSearchDropdown:
        "Search Dropdown Shadow (Pickup and Where location dropdown) ",
      shadowSearchDropdownInset:
        "Search Dropdown Inside Shadow (Pickup and Where location dropdown) ",
      shadowMapPopup: "Map Popup Shadow (View Map) ",
      shadowMapPopupInset: "Map Popup Inside Shadow (View Map) ",
      shadowTopPopup: "Top Popup Shadow (Add cards)",
      shadowTopPopupInset: "Top Popup Inside Shadow (Add cards)",
      shadowLeftSidebar: "Left Sidebar Shadow (Side Menu)",
      shadowLeftSidebarInset: "Left Sidebar Inside Shadow (Side Menu)",
      // shadowRightSidebar:"Right Sidebar Shadow (Chat window, Guest Payment Form)",
      shadowRightSidebar: "Right Sidebar Shadow (Chat window)",
      // shadowRightSidebarInset:"Right Sidebar Inside Shadow (Chat window, Guest Payment Form)",
      shadowRightSidebarInset: "Right Sidebar Inside Shadow (Chat window)",
      shadowAISidebar: "AI Sidebar Shadow",
      shadowAISidebarInset: "AI Sidebar Inside Shadow",
      shadowMainAITextarea: "AI Screen Textarea Shadow",
      shadowMainAITextareaInset: "AI Screen Textarea Inset Shadow",
      shadowFormGroup: "Form Group Shadow",
      shadowFormGroupInset: "Form Group Inside Shadow",
      shadowInput: "Input Box Shadow",
      shadowText: "Text Shadow",
      shadowListRow: "List Shadow",
      shadowTableRow: "Table Shadow",
      shadowVehicleList: "Vehicle List Shadow",
      shadowVehicleListInset: "Vehicle List Inside Shadow",
      pluginShadow: "Plugin Shadow",
      //   pluginInset: "Plugin Inside Shadow",
      textarea: "Textarea Shadow",
      pluginInsideLeftShadow: "Plugin Inside Left Shadow",
      pluginInsideRightShadow: "Plugin Inside Right Shadow",
      pluginInsideTopShadow: "Plugin Inside Top Shadow",
      pluginInsideBottomShadow: "Plugin Inside Bottom Shadow",
      shortcutMenu: "Shortcut Menu Shadow (Chat window action icons)",
      shortcutMenuInset:
        "Shortcut Menu Inside Shadow (Chat window action icons)",
      // smallButton: "Small Button Shadow",
      // sidePopup: "Side Popup Shadow",

      shadowVehicleListDefault: "Vehicle List Default Shadow",
      shadowVehicleListDefaultInset: "Vehicle List Default Inside Shadow", 
      
      shadowVehicleListSelection: "Vehicle List Selection Shadow",
      shadowVehicleListSelectionInset: "Vehicle List Selection Inside Shadow", 
      
      shadowTabCarouselDefault: "Vehicle Tab Carousel Default Shadow",
      shadowTabCarouselDefaultInset: "Vehicle Tab Carousel Default Inside Shadow",  
      
      shadowTabCarouselSelection: "Vehicle Tab Carousel Selection Shadow",
      shadowTabCarouselSelectionInset: "Vehicle Tab Carousel Selection Inside Shadow", 
      
      shadowVehicleDashboardDefault: "Vehicle Dashboard Default Shadow",
      shadowVehicleDashboardDefaultInset: "Vehicle Dashboard Default Inside Shadow", 
      
      shadowVehicleDashboardSelection: "Vehicle Dashboard Selection Shadow",
      shadowVehicleDashboardSelectionInset: "Vehicle Dashboard Selection Inside Shadow",
    };
    return labels[key] || key;
  };

  handleInputChangeShadows = (type, value) => {
    this.setState((prevState) => ({
      shadows: {
        ...prevState.shadows,
        [type]: value,
      },
    }));
  };

  handleSettingsNotesOpenPopup = (label) => {
    this.setState({ settingsNotesPopup: true, infoSliderName: label });
  };
  handleSettingsNotesClosePopup = () => {
    this.setState({ settingsNotesPopup: false, infoSliderName: "" });
  };
  /**Shadow end */

  Capitalize(str) {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1) || "";
  }
  addFunc = (e) => {
    this.setState((prevState) => ({
      fontDetails: [
        ...prevState.fontDetails,
        {
          index: Math.random(),
          FontType: "",
          FontId: "",
          fontSize: "",
          fontWeight: "",
          letterSpacing: "",
          lineHeight: "",
          TopSpace: "",
          BottomSpace: "",
          varient_id: "",
        },
      ],
    }));
  };

  /**Radius management start */
  // labelFor = (key) => {
  // 	const labels = {
  // 		// shadow labels ...
  // 		pluginRadius: "Plugin Radius",
  // 		dropdownRadius: "Dropdown Menu Radius",
  // 		inputRadius: "Input Box Radius",
  // 		textareaRadius: "Textarea Radius",
  // 		dashboardGridRadius: "Dashboard Grid Radius",
  // 		dashboardListRadius: "Dashboard List Radius",
  // 		listRowRadius: "List Row Radius",
  // 		mapPopupRadius: "Map Popup Radius",
  // 		formGroupRadius: "Form Group Radius",
  // 		mainAITextareaRadius: "AI Screen Textarea Radius",
  // 	};
  // 	return labels[key] || key;
  // };

  /**Radius management end */
  /**AI sidebar management start */
  // labelFor = (key) => {
  // 	const labels = {
  // 		// existing ones...
  // 		aiSidebarRadius: "AI Sidebar Radius",
  // 		aiSidebarShadow: "AI Sidebar Shadow",
  // 		aiSidebarShadowInset: "AI Sidebar Inside Shadow",
  // 		aiSidebarBackground: "AI Sidebar Background",
  // 	};
  // 	return labels[key] || key;
  // };

  /**AI sidebar management end */

  /**Font management start */
  addMoreFunc = () => {
    const { fontDetails } = this.state;

    if (!fontDetails || !Array.isArray(fontDetails)) return null;

    return fontDetails.map((val, idx) => {
      const formattedName = val.listName.replace(/\s+/g, "_");
      const FontType = `FontType${idx}`,
        fontWeight = `fontWeight${idx}`,
        FontSize = `FontSize${idx}`,
        letterSpacing = `letterSpacing${idx}`,
        lineHeight = `lineHeight${idx}`,
        TopSpace = `TopSpace${idx}`,
        BottomSpace = `BottomSpace${idx}`,
        radius = `radius${idx}`,
        errorfile = `errorfile${idx}`;

      // Radius images
      const insidefontManagementImages = {
        Primary: [
          {
            title: "Primary",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        // Menu_Logo: [
        // 	{
        // 		title: 'Menu Logo',
        // 		src: assetUrl + "theme_notes/radius/plugin-radius.png",
        // 	},
        // ],
        Main_Tab: [
          {
            title: "Main Tab",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        Side_Menu: [
          {
            title: "Side Menu",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        Title: [
          {
            title: "Title",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        Sub_Title: [
          {
            title: "Sub Title",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        List_Font: [
          {
            title: "List Font",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        List_Title_Font: [
          {
            title: "List Title Font",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        List_Serial_No_Font: [
          {
            title: "List Serial No Font",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        Dashboard_List: [
          {
            title: "Dashboard List",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        Dashboard_List_Count: [
          {
            title: "Dashboard List Count",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        Large_Button: [
          {
            title: "Large Button",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        Small_Button: [
          {
            title: "Small Button",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        Plugin_Open_Button: [
          {
            title: "Plugin Open Button",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        AI_Chat_Summary_Title: [
          {
            title: "AI Chat Summary Title",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        AI_Chat_Summary: [
          {
            title: "AI Chat Summary",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        AI_Profile_Name: [
          {
            title: "AI Profile Name",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        Form_Label: [
          {
            title: "Form Label",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        Form_Input_Placeholder: [
          {
            title: "Form Input Placeholder",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        Form_Input_Value: [
          {
            title: "Form Input Value",
            src: assetUrl + "theme_notes/radius/plugin-radius.png",
          },
        ],
        Sub_Tab: [
          {
            title: "Sub Tab",
            src: assetUrl + "theme_notes/radius/sub-tab.png",
          },
        ],
        Invite_Page_Title: [
          {
            title: "Invite Page Title",
            src: assetUrl + "theme_notes/font/Invite-page-title.png",
          },
        ],
      };

      return (
        <div key={idx}>
          <div className="form-row mb-0">
            <div className="form-left">
              <div className="form-group">
                <h4
                  className="title text-start"
                  onClick={() =>
                    this.handleSettingsNotesOpenPopup(formattedName)
                  }
                >
                  {val.listName} :{" "}
                  {Object.keys(insidefontManagementImages).includes(
                    formattedName,
                  ) && (
                    <i className="fa fa-info-circle ms-2 fs-6 cursor-pointer"></i>
                  )}
                </h4>
              </div>
            </div>
          </div>

          <div className="form-row mb-5">
            {this.varientField(
              val.font_id,
              val.fontFamily,
              val.FontType,
              idx,
              val,
              idx,
            )}
          </div>
        </div>
      );
    });
  };

  handleFileChangeVarients = async (e, idx, fontLabel, fontValue) => {
    let font_file = `font_file${idx}`;
    let fontDetails = [...this.state.fontDetails];

    fontDetails[idx] = {
      ...fontDetails[idx],
      fontWeight: e.target.value,
    };
    fontDetails[e.target.dataset.id]["varient_id"] = idx;
    fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
    let selectedFont = e.target.name;
    this.setState({ fontDetails }, () => {
      console.log(this.state.fontDetails, "Updated fontDetails");
    });
  };

  varientField = (FontId, FontFamily, FontType, idx, val, selIndex) => {
    const fontArray = this.state.fonttype.map((fonttype, index) => ({
      id: index,
      name: fonttype,
    }));

    let fonts = [];
    fontArray.map((item) =>
      fonts.push({
        label: item.name.label,
        value: item.name.value,
        fontStyles: item.name.tf_fontStyles,
        typeIs: item.name.tf_font_type,
        type: item.name.type,
      }),
    );

    let fontWeight = `fontWeight${idx}`,
      FontSize = `FontSize${idx}`,
      FontIndId = `FontId${idx}`,
      letterSpacing = `letterSpacing${idx}`,
      lineHeight = `lineHeight${idx}`,
      TopSpace = `TopSpace${idx}`,
      BottomSpace = `BottomSpace${idx}`,
      radius = `radius${idx}`,
      textColor = `textColor${idx}`,
      textBgColor = `textBgColor${idx}`,
      textBorderColor= `textBorderColor${idx}`,
      textBorderSize=`textBorderSize${idx}`,
      textIconSize =`textIconSize${idx}`,
      fontFamilyError = `fontFamilyError${idx}`,
      fontVariantError = `fontVariantError${idx}`,
      fontSizeError = `fontSizeError${idx}`,
      letterSpacingError = `letterSpacingError${idx}`,
      topSpaceError = `topSpaceError${idx}`,
      bottomSpaceError = `bottomSpaceError${idx}`,
      radiusError = `radiusError${idx}`,
      textColorError =`textColorError${idx}`,
      textBgColorError =`textBgColorError${idx}`,
      textBorderColorError =`textBorderColorError${idx}`,
      textBorderSizeError = `textBorderSizeError${idx}`,
      textIconSizeError =`textIconSizeError${idx}`
      ;
    //if(FontType !=='smallButton' && FontType!=='largeButton'){
    return (
      <>
        <div className="form-left">
          <div className="form-group">
            <label>
              Font Family
              <span class="required" style={{ color: "red" }}>
                {" "}
                *{" "}
              </span>{" "}
              :
            </label>
            <div>
              <select
                name="font_id"
                className="form-control"
                id={FontType}
                data-id={idx}
                value={val.font_id?.toString() || ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  const selectedOption = fonts.find(
                    (option) => option.value === selectedValue,
                  );
                  this.handleFileChange(
                    e,
                    idx,
                    selectedOption?.label,
                    selectedOption?.value,
                  );
                }}
              >
                <option value="">Select Font</option>

                <optgroup label="System Fonts">
                  {fonts
                    .filter((f) => f.type === "system_font")
                    .map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                </optgroup>
                <optgroup label="Google Fonts">
                  {fonts
                    .filter((f) => f.type === "google_font")
                    .map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                </optgroup>
                {console.log(fonts, "this is for fonts label")}
                <optgroup label="Custom Fonts">
                  {fonts
                    .filter((f) => f.type === "normal_font")
                    .map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                </optgroup>
              </select>
              <div className={fontFamilyError}></div>
            </div>
          </div>
        </div>
        <div className="form-right">
          <div className="form-group">
            <label>
              Font Variant
              <span class="required" style={{ color: "red" }}>
                {" "}
                *{" "}
              </span>{" "}
              :
            </label>
            <div>
              <select
                name="fontWeight"
                className="form-control"
                id={FontType}
                data-id={idx}
                onChange={(e) => this.handleFileChangeVarients(e, idx)}
              >
                <option value="" className="fontVarientName">
                  Select Variant
                </option>
                {/* {this.state.fontDetails[idx]?.variants?.map((variant) => (
						<option
							key={variant.value}
							value={variant.value || val.fontWeight}
							selected={val.fontWeight == variant.value ? true : false}
						>
							{variant.label} {variant.value}
						</option>
						))} */}
                {(this.state.fontDetails[idx]?.variants &&
                this.state.fontDetails[idx].variants.length > 0
                  ? this.state.fontDetails[idx].variants
                  : [
                      { value: 100, label: "Thin" },
                      { value: 200, label: "Extra Light" },
                      { value: 300, label: "Light" },
                      { value: 400, label: "Regular" },
                      { value: 500, label: "Medium" },
                      { value: 600, label: "Semi Bold" },
                      { value: 700, label: "Bold" },
                      { value: 800, label: "Extra Bold" },
                      { value: 900, label: "Black" },
                    ]
                ).map((variant) => (
                  <option
                    key={variant.value}
                    value={variant.value}
                    selected={val.fontWeight == variant.value}
                  >
                    {variant.label} {variant.value}
                  </option>
                ))}
              </select>

              <div className={fontVariantError}></div>
            </div>
          </div>
        </div>

        <div className="form-left">
          <div className="form-group">
            <label>
              Font Size
              <span class="required" style={{ color: "red" }}>
                {" "}
                *{" "}
              </span>{" "}
              :
            </label>
            <div>
              <input
                type="text"
                name="fontSize"
                onChange={(e) => this.handleFileChange(e, idx)}
                //onChange={this.onFileChange}
                value={val.fontSize}
                data-id={idx}
                id={FontSize}
              />

              <div className={fontSizeError}></div>
            </div>
          </div>
        </div>
        <div className="form-right">
          <div className="form-group">
            <label>
              Letter Spacing
              <span class="required" style={{ color: "red" }}>
                {" "}
                *{" "}
              </span>{" "}
              :
            </label>
            <div>
              <input
                type="text"
                name="letterSpacing"
                onChange={(e) => this.handleFileChange(e, idx)}
                //onChange={this.onFileChange}
                value={val.letterSpacing}
                data-id={idx}
                id={letterSpacing}
              />

              <div className={letterSpacingError}></div>
            </div>
          </div>
        </div>
        {/* {console.log(FontType, "thi is fonttype")} */}
        {FontType == "smallbutton" ||
        FontType == "largebutton" ||
        FontType == "pluginOpenButton" ||
        FontType == "cardViewHighlight" ||
        FontType == "tagLabel" 
        ? (
          <>
            <div className="form-left">
              <div className="form-group">
                <label>
                  Top Space
                  <span class="required" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>{" "}
                  :
                </label>
                <div>
                  <input
                    type="text"
                    name="topSpace"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.topSpace}
                    data-id={idx}
                    id={TopSpace}
                  />

                  <div className={topSpaceError}></div>
                </div>
              </div>
            </div>
            <div className="form-right">
              <div className="form-group">
                <label>
                  Bottom Space
                  <span class="required" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>{" "}
                  :{" "}
                </label>
                <div>
                  <input
                    type="text"
                    name="bottomSpace"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.bottomSpace}
                    data-id={idx}
                    id={BottomSpace}
                  />
                  <div className={bottomSpaceError}></div>
                </div>
              </div>
            </div>
            <div className="form-left">
              <div className="form-group">
                <label>
                  Radius
                  <span class="required" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>{" "}
                  :{" "}
                </label>
                <div>
                  <input
                    type="text"
                    name="radius"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.radius}
                    data-id={idx}
                    id={radius}
                  />

                  <div className={radiusError}></div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
         {
        (FontType == "cardViewHighlight" ||
        FontType == "tagLabel")
        && (<>
            <div className="form-right">
              <div className="form-group">
                <label>
                  Text Color
                  {/* <span class="required" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span> */}
                  {" "}
                  :
                </label>
                <div className="d-flex form-field-accessibility-row">
                  <div className="form-field-accessibility-input">
                   <input
                    id={textColor}
                    name="textColor" 
                    type="text"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.textColor}
                    
                  />
                  </div>
                  <div className="form-field-accessibility-colorbx">
                  <input type="color" 
                  data-id={idx}
                  className="form-control"
                  id={textColor}
                  name="textColor" 
                  value={val.textColor} 
                  onChange={(e) => this.handleFileChange(e, idx)} />
                  </div>
                  <div className={textColorError}></div>
                </div>
              </div>
            </div>
             <div className="form-right">
              <div className="form-group">
                <label>
                  Text Background Color
                  {/* <span class="required" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span> */}
                  {" "}
                  :
                </label>
                <div className="d-flex form-field-accessibility-row">
                  <div className="form-field-accessibility-input">
                   <input
                    id={textBgColor}
                    name="textBgColor" 
                    type="text"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.textBgColor}
                    
                  />
                  </div>
                  <div className="form-field-accessibility-colorbx">
                  <input type="color" 
                  data-id={idx}
                  className="form-control"
                  id={textBgColor}
                  name="textBgColor" 
                  value={val.textBgColor} 
                  onChange={(e) => this.handleFileChange(e, idx)} />
                  </div>
                  <div className={textBgColorError}></div>
                </div>
              </div>
            </div>
            <div className="form-right">
              <div className="form-group">
                <label>
                  Border Size
                  {" "}
                  :
                </label>
                <div>
                  <input
                    type="text"
                    name="textBorderSize"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.textBorderSize}
                    data-id={idx}
                    id={textBorderSize}
                  />

                  <div className={textBorderSizeError}></div>
                </div>
              </div>
            </div>

             <div className="form-right">
              <div className="form-group">
                <label>
                  Text Color
                  {/* <span class="required" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span> */}
                  {" "}
                  :
                </label>
                <div className="d-flex form-field-accessibility-row">
                  <div className="form-field-accessibility-input">
                   <input
                    id={textBorderColor}
                    name="textBorderColor" 
                    type="text"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.textBorderColor}
                    
                  />
                  </div>
                  <div className="form-field-accessibility-colorbx">
                  <input type="color" 
                  data-id={idx}
                  className="form-control"
                  id={textBorderColor}
                  name="textBorderColor" 
                  value={val.textBorderColor} 
                  onChange={(e) => this.handleFileChange(e, idx)} />
                  </div>
                  <div className={textBorderColorError}></div>
                </div>
              </div>
            </div>
            <div className="form-left">
              <div className="form-group">
                <label>
                  Icon Size :
                 
                </label>
                <div>
                  <input
                    type="text"
                    name="textIconSize"
                    onChange={(e) => this.handleFileChange(e, idx)}
                    value={val.textIconSize}
                    data-id={idx}
                    id={textIconSize}
                  />
                  <div className={textIconSizeError}></div>
                </div>
              </div>
            </div>
               
        </> 
        )}
      </>
    );
  };

  handleFileChange = async (e, idx, fontLabel, fontValue) => {
    let font_file = `font_file${idx}`;
    let fontDetails = [...this.state.fontDetails];
    fontDetails[e.target.dataset.id]["varient_id"] = idx;
    fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
    if(e.target.name === "textBgColor"){
        const hex = e.target.value;

        const { filter, loss } = computeFilterFromHex(hex);
        fontDetails[e.target.dataset.id]['textIconFilterColor'] = filter;
    }
   
    let selectedFont = e.target.name;
    if (fontValue) {
      try {
        const response = await axios.get(`${apiUrl}font/getvarientlistdetail`, {
          params: {
            id: fontValue,
            name: fontLabel,
          },
        });
        if (response.data.variants) {
          fontDetails[idx] = {
            ...fontDetails[idx],
            variants: response.data.variants,
          };
          console.log(response.data.variants, "this is fortvarientrecords");
        }
      } catch (error) {
        console.error("Error fetching font variants:", error);
      }
    }

    this.setState({ fontDetails }, () => {
      console.log(this.state.fontDetails, "Updated fontDetails");
    });
  };
  /**Font management end */

  /**Clone theme start */
  confirmThemePopup = (title) => {
    //this.setState({ formAction: "clone", cloneTitle: title + " Copy", showClonePopup: true });
    this.setState({
      formAction: "clone",
      cloneTitle: "",
      showClonePopup: true,
    });
  };
  /**Clone theme end */

  render() {
    const { selectedOption } = this.state;

    const settings = {
      dots: false,
      infinite: false, // disable infinite loop
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    /**Shadow images start */
    const shadowImages = {
      shadowPluginOpenButton: [
        {
          title: "Plugin Open Button Shadow",
          src: assetUrl + "theme_notes/shadow/plugin-open-button-shadow.png",
        },
      ],
      shadowPluginOpenButtonInset: [
        {
          title: "Plugin Open Inside Button Shadow",
          src:
            assetUrl + "theme_notes/shadow/plugin-open-button-inner-shadow.png",
        },
      ],
      largeButton: [
        {
          title: "Button Shadow",
          src: assetUrl + "theme_notes/shadow/buttons-shadow.png",
        },
      ],
      shadowButtonInset: [
        {
          title: "Button Inside Shadow",
          src: assetUrl + "theme_notes/shadow/buttons-inner-shadow.png",
        },
      ],
      dashboardShadowGrid: [
        {
          title: "Dashboard Grid Shadow",
          src: assetUrl + "theme_notes/shadow/dashboard-grid-shadow.png",
        },
      ],
      shadowDashboardGridInset: [
        {
          title: "Dashboard Grid Inside Shadow",
          src: assetUrl + "theme_notes/shadow/dashboard-grid-inner-shadow.png",
        },
      ],
      dashboardShadowList: [
        {
          title: "Dashboard List Shadow",
          src: assetUrl + "theme_notes/shadow/dashboard-list-shadow.png",
        },
      ],
      shadowDashboardListInset: [
        {
          title: "Dashboard List Inside Shadow",
          src: assetUrl + "theme_notes/shadow/dashboard-list-inner-shadow.png",
        },
      ],
      dropdownmenu: [
        {
          title: "Bell notification dropdown shadow",
          src:
            assetUrl +
            "theme_notes/shadow/bell-notification-dropdown-shadow.png",
        },
        {
          title: "Address dropdown shadow",
          src: assetUrl + "theme_notes/shadow/address-dropdown-shadow.png",
        },
        {
          title: "Group menu in listing screen shadow",
          src:
            assetUrl +
            "theme_notes/shadow/group-menu-listing-screen-shadow.png",
        },
        {
          title: "Profile dropdown shadow",
          src: assetUrl + "theme_notes/shadow/profile-dropdown-shadow.png",
        },
        {
          title: "Chat window emojis dropdown shadow",
          src:
            assetUrl +
            "theme_notes/shadow/chat-window-emojis-dropdown-shadow.png",
        },
        // {
        // title: "All message popup shadow",
        // src: assetUrl + "theme_notes/shadow/All-message-popup-shadow.png",
        // },
      ],
      shadowDropdownMenuInset: [
        {
          title: "Bell notification dropdown inside shadow",
          src:
            assetUrl +
            "theme_notes/shadow/bell-notification-dropdown-inner-shadow.png",
        },
        {
          title: "Address dropdown inside shadow",
          src:
            assetUrl + "theme_notes/shadow/address-dropdown-inner-shadow.png",
        },

        {
          title: "Group menu in listing screen inside shadow",
          src:
            assetUrl +
            "theme_notes/shadow/group-menu-listing-screen-inner-shadow.png",
        },
        {
          title: "Profile dropdown inside shadow",
          src:
            assetUrl + "theme_notes/shadow/profile-dropdown-inner-shadow.png",
        },
        {
          title: "Chat window emojis dropdown inside shadow",
          src:
            assetUrl +
            "theme_notes/shadow/chat-window-emojis-dropdown-inner-shadow.png",
        },
        // {
        // title: "All message popup inside shadow",
        // src: assetUrl + "theme_notes/shadow/All-message-popup-shadow.png",
        // },
      ],
      shadowSearchDropdown: [
        {
          title: "Search dropdown shadow",
          src: assetUrl + "theme_notes/shadow/search-dropdown-shadow.png",
        },
      ],
      shadowSearchDropdownInset: [
        {
          title: "Search dropdown inside shadow",
          src: assetUrl + "theme_notes/shadow/search-dropdown-inner-shadow.png",
        },
      ],
      shadowMapPopup: [
        {
          title: "View Map Popup Shadow",
          src: assetUrl + "theme_notes/shadow/map-popup-shadow.png",
        },
      ],
      shadowMapPopupInset: [
        {
          title: "View Map Popup Inside Shadow",
          src: assetUrl + "theme_notes/shadow/map-popup-inner-shadow.png",
        },
      ],
      shadowTopPopup: [
        {
          title: "Add Card Popup Shadow",
          src: assetUrl + "theme_notes/shadow/top-popup-shadow.png",
        },
      ],
      shadowTopPopupInset: [
        {
          title: "Add Card Popup Inside Shadow",
          src: assetUrl + "theme_notes/shadow/top-popup-inner-shadow.png",
        },
      ],
      shadowLeftSidebar: [
        {
          title: "Side Menu Shadow",
          src: assetUrl + "theme_notes/shadow/left-sidebar-shadow.png",
        },
      ],
      shadowLeftSidebarInset: [
        {
          title: "Side Menu Inside Shadow",
          src: assetUrl + "theme_notes/shadow/left-sidebar-inner-shadow.png",
        },
      ],
      shadowRightSidebar: [
        {
          title: "Chat Window Shadow",
          src: assetUrl + "theme_notes/shadow/chat-window-shadow.png",
        },
        // {
        // title: "Guest Payment Form Shadow",
        // src: assetUrl + "theme_notes/shadow/shadow-plugin.png",
        // }
      ],
      shadowRightSidebarInset: [
        {
          title: "Chat Window Inside Shadow",
          src: assetUrl + "theme_notes/shadow/chat-window-inner-shadow.png",
        },
        // {
        // title: "Guest Payment Form Inside Shadow",
        // src: assetUrl + "theme_notes/shadow/shadow-plugin.png",
        // }
      ],
      shadowAISidebar: [
        {
          title: "AI Screen Sidebar Shadow",
          src: assetUrl + "theme_notes/shadow/ai-sidebar-shadow.png",
        },
      ],
      shadowAISidebarInset: [
        {
          title: "AI Screen Sidebar Inside Shadow",
          src: assetUrl + "theme_notes/shadow/ai-sidebar-inner-shadow.png",
        },
      ],
      shadowMainAITextarea: [
        {
          title: "AI Screen Textarea Shadow",
          src: assetUrl + "theme_notes/shadow/ai-screen-textarea-shadow.png",
        },
      ],
      shadowMainAITextareaInset: [
        {
          title: "AI Screen Textarea Inside Shadow",
          src:
            assetUrl + "theme_notes/shadow/ai-screen-textarea-inner-shadow.png",
        },
      ],
      shadowFormGroup: [
        {
          title: "Form Group Shadow",
          src: assetUrl + "theme_notes/shadow/form-group-shadow.png",
        },
      ],
      shadowFormGroupInset: [
        {
          title: "Form Group Inside Shadow",
          src: assetUrl + "theme_notes/shadow/form-group-inner-shadow.png",
        },
      ],
      shadowInput: [
        {
          title: "Input Box Shadow",
          src: assetUrl + "theme_notes/shadow/input-box-shadow.png",
        },
      ],
      shadowText: [
        {
          title: "Text Shadow (Result text)",
          src: assetUrl + "theme_notes/shadow/text-shadow.png",
        },
      ],
      shadowListRow: [
        {
          title: "List Shadow",
          src: assetUrl + "theme_notes/shadow/list-shadow.png",
        },
      ],
      shadowTableRow: [
        {
          title: "Table Shadow",
          src: assetUrl + "theme_notes/shadow/table-shadow.png",
        },
      ],
      pluginShadow: [
        {
          title: "Plugin Shadow",
          src: assetUrl + "theme_notes/shadow/plugin-shadow.png",
        },
      ],
      textarea: [
        {
          title: "Textarea Shadow",
          src: assetUrl + "theme_notes/shadow/textarea-shadow.png",
        },
      ],
      pluginInsideLeftShadow: [
        {
          title: "Plugin Inside Left Shadow",
          src: assetUrl + "theme_notes/shadow/plugin-left-inner-shadow.png",
        },
      ],
      pluginInsideRightShadow: [
        {
          title: "Plugin Inside Right Shadow",
          src: assetUrl + "theme_notes/shadow/plugin-right-inner-shadow.png",
        },
      ],
      pluginInsideTopShadow: [
        {
          title: "Plugin Inside Top Shadow",
          src: assetUrl + "theme_notes/shadow/plugin-top-inner-shadow.png",
        },
      ],
      pluginInsideBottomShadow: [
        {
          title: "Plugin Inside Bottom Shadow",
          src: assetUrl + "theme_notes/shadow/plugin-bottom-inner-shadow.png",
        },
      ],
      shortcutMenu: [
        {
          title: "Chat window action icons shadow",
          src:
            assetUrl + "theme_notes/shadow/chat-window-action-icons-shadow.png",
        },
      ],
      shortcutMenuInset: [
        {
          title: "Chat window action icons inner shadow",
          src:
            assetUrl +
            "theme_notes/shadow/chat-window-action-icons-inner-shadow.png",
        },
      ],
    };
    /**Shadow images end */
     /**Image size manangement start */
      const imageSize = {
        adImage: [
        {
          title: "Ads image",
          src: assetUrl + "theme_notes/imagesize/ads-image.png",
        },
       ],
        adPopupimage: [
        {
          title: "Ads popup image",
          src: assetUrl + "theme_notes/imagesize/ads-popup-image-2.png",
        }
       
        ],
        membershipimage: [
        {
          title: "Membership Image",
          src: assetUrl + "theme_notes/imagesize/membership-image.png",
        },
        ],
        inviteimage: [
        {
          title: "Invite page Image",
          src: assetUrl + "theme_notes/imagesize/Invite-page-image.png",
        },
        ],
      }
     /**Image size manangement end */

    /**Radius images start */
    const radiusImages = {
      pluginRadius: [
        {
          title: "Plugin Radius",
          src: assetUrl + "theme_notes/radius/plugin.png",
        },
      ],
      dropdownRadius: [
        {
          title: "Bell notification radius",
          src: assetUrl + "theme_notes/radius/bell-notification.png",
        },
        {
          title: "Group menu in listing screen radius",
          src: assetUrl + "theme_notes/radius/listing-screen-group-menu.png",
        },
        {
          title: "Message box radius",
          src: assetUrl + "theme_notes/radius/confirmation-messgae-popup.png",
        },
        {
          title: "Claim rewards radius",
          src: assetUrl + "theme_notes/radius/claim-reward-popup.png",
        },
        {
          title: "Address dropdown radius",
          src: assetUrl + "theme_notes/radius/address-dropdown.png",
        },
      ],
      inputRadius: [
        {
          title: "Input Box Radius",
          src: assetUrl + "theme_notes/radius/input-box.png",
        },
      ],
      textareaRadius: [
        {
          title: "Textarea Radius",
          src: assetUrl + "theme_notes/radius/textarea.png",
        },
      ],
      dashboardGridRadius: [
        {
          title: "Dashboard Grid Radius",
          src: assetUrl + "theme_notes/radius/dashboard-grid.png",
        },
      ],
      dashboardListRadius: [
        {
          title: "Dashboard List Radius",
          src: assetUrl + "theme_notes/radius/dashboard-list.png",
        },
      ],
      listRowRadius: [
        {
          title: "List Row Radius",
          src: assetUrl + "theme_notes/radius/list.png",
        },
      ],
      mapPopupRadius: [
        {
          title: "Map Popup Radius",
          src: assetUrl + "theme_notes/radius/map-popup.png",
        },
      ],
      formGroupRadius: [
        {
          title: "Form Group Radius",
          src: assetUrl + "theme_notes/radius/form-group.png",
        },
      ],
      mainAITextareaRadius: [
        {
          title: "AI Screen Textarea Radius",
          src: assetUrl + "theme_notes/radius/ai-screen-textarea.png",
        },
      ],
      topPopupRadius: [
        {
          title: "AI Screen Top Popup Radius",
          src: assetUrl + "theme_notes/radius/top-popup-radius.png",
        },
      ],
    };
    /**Radius images end */

    /**AI sidebar images start */
    const aiSidebarImages = {
      ai_side_menu_width: [
        {
          title: "AI Sidebar Expended Size",
          src: assetUrl + "theme_notes/ai_sidebar/sidebar-expended- size.png",
        },
      ],
      st_aisidebar_collapsed_width: [
        {
          title: "AI Sidebar Collapsed Size",
          src: assetUrl + "theme_notes/ai_sidebar/sidebar-collapsed-size.png",
        },
      ],
      st_aisidebar_icon_width: [
        {
          title: "AI Sidebar Icon Size",
          src: assetUrl + "theme_notes/ai_sidebar/sidebar-icon-size.png",
        },
      ],
    };
    /**AI sidebar images end */

    /** Line height images start */
    const fontManagementImages = {
      line_height: [
        {
          title: "Line Height",
          src: assetUrl + "theme_notes/font/line-height.png",
        },
      ],
    };
    /** Line height images end */

    /**Font management images start */
    const insidefontManagementImages = {
      Primary: [
        {
          title: "Primary",
          src: assetUrl + "theme_notes/font/primary.png",
        },
      ],
      // Menu_Logo: [
      // 	{
      // 		title: 'Menu Logo',
      // 		src: assetUrl + "theme_notes/radius/plugin-radius.png",
      // 	},
      // ],
      Main_Tab: [
        {
          title: "Main Tab",
          src: assetUrl + "theme_notes/font/main-tab.png",
        },
      ],
      Side_Menu: [
        {
          title: "Side Menu",
          src: assetUrl + "theme_notes/font/side-menu.png",
        },
      ],
      Title: [
        {
          title: "Header title",
          src: assetUrl + "theme_notes/font/header-title.png",
        },
        {
          title: "Booking form vehicles list title",
          src:
            assetUrl + "theme_notes/font/booking-form-vehicles-list-title.png",
        },
        {
          title: "Membership tabs title",
          src: assetUrl + "theme_notes/font/membership-tabs-title.png",
        },
        {
          title: "Add card popup title",
          src: assetUrl + "theme_notes/font/add-card-popup-title.png",
        },
        {
          title: "User login form title",
          src: assetUrl + "theme_notes/font/user-login-form-title.png",
        },
      ],
      Sub_Title: [
        {
          title: "Booking form vehicle sub title",
          src: assetUrl + "theme_notes/font/booking-form-vehicle-sub-title.png",
        },
        {
          title: "View screen sub title",
          src: assetUrl + "theme_notes/font/view-screen-sub-title.png",
        },
        {
          title: "Membership form sub title",
          src: assetUrl + "theme_notes/font/membership-form-sub-title.png",
        },
      ],
      List_Font: [
        {
          title: "List Font",
          src: assetUrl + "theme_notes/font/list-font.png",
        },
        {
          title: "Table view list Font",
          src: assetUrl + "theme_notes/font/table-view-list.png",
        },
      ],
      List_Title_Font: [
        {
          title: "List Title Font",
          src: assetUrl + "theme_notes/font/list-title.png",
        },
        {
          title: "Table view list Title Font",
          src: assetUrl + "theme_notes/font/table-view-list-title.png",
        },
      ],
      List_Serial_No_Font: [
        {
          title: "List Serial No Font",
          src: assetUrl + "theme_notes/font/list-serial-no.png",
        },
      ],
      Dashboard_List: [
        {
          title: "Dashboard List",
          src: assetUrl + "theme_notes/font/dashboard-list-name.png",
        },
      ],
      Dashboard_List_Count: [
        {
          title: "Dashboard List Count",
          src: assetUrl + "theme_notes/font/dashboard-list-count.png",
        },
      ],
      Large_Button: [
        {
          title: "Large Button",
          src: assetUrl + "theme_notes/font/large-button.png",
        },
      ],
      Small_Button: [
        {
          title: "Small Button",
          src: assetUrl + "theme_notes/font/small-button.png",
        },
      ],
      Plugin_Open_Button: [
        {
          title: "Plugin Open Button",
          src: assetUrl + "theme_notes/font/plugin-open-button.png",
        },
      ],
      AI_Chat_Summary_Title: [
        {
          title: "AI Chat Summary Title",
          src: assetUrl + "theme_notes/font/ai-sidebar-chat-summary-title.png",
        },
      ],
      AI_Chat_Summary: [
        {
          title: "AI Chat Summary",
          src: assetUrl + "theme_notes/font/ai-sidebar-chat-summary.png",
        },
      ],
      AI_Profile_Name: [
        {
          title: "AI Profile Name",
          src: assetUrl + "theme_notes/font/ai-profile-name.png",
        },
      ],
      Form_Label: [
        {
          title: "Form Label",
          src: assetUrl + "theme_notes/font/form-label.png",
        },
      ],
      Form_Input_Placeholder: [
        {
          title: "Form Input Placeholder",
          src: assetUrl + "theme_notes/font/form-input-placeholder.png",
        },
      ],
      Form_Input_Value: [
        {
          title: "Form Input Value",
          src: assetUrl + "theme_notes/font/form-input-value.png",
        },
      ],
      Sub_Tab: [
        {
          title: "Sub Tab",
          src: assetUrl + "theme_notes/font/sub-tab.png",
        },
      ],
      Invite_Page_Title: [
        {
          title: "Invite page Title",
          src: assetUrl + "theme_notes/font/Invite-page-title.png",
        },
      ]
     
    };
    /** Font management images end */

    return (
      <div className="wrapper">
        {this.state.showClonePopup && (
          <div className="popup-sec active">
            <div className="popup-sec-in h-auto">
              <p>Enter a title for cloned theme:</p>
              <input
                type="text"
                value={this.state.cloneTitle}
                name="cloneTitle"
                //onChange={(e) => this.setState({ cloneTitle: e.target.value })}
                onChange={this.handleInputPopupChange}
                className="form-control"
              />
              <div className="errorcloneTitle"></div>
              <div className="d-flex gap-4 justify-content-center mt-4">
                <a
                  href="javascript://"
                  onClick={() => {
                    this.handleFormSubmit(this);
                  }}
                  className="btn"
                >
                  Clone
                </a>
                <a
                  href="javascript://"
                  onClick={() =>
                    this.setState({
                      showClonePopup: false,
                      cloneTitle: "",
                      formAction: "edit",
                    })
                  }
                  className="btn"
                >
                  Cancel
                </a>
              </div>
            </div>
          </div>
        )}
        <Header />
        <MenuSidebar currentpage="themes" currentTab="common" />
        <div className="content">
          <div className="content-wrapper">
            <div className="content-wrapper-before"></div>
            <div className="form-wrapper leaa-admin-head card">
              <div className="success_message"></div>
              <div>
                <a className="btn" href="/theme">
                  Back
                </a>
              </div>
              <div className="title">
                <h4>Edit Theme</h4>
              </div>
              <form
                className="login"
                id="login"
                onSubmit={(e) => {
                  this.handleFormSubmit(this);
                  e.preventDefault();
                }}
              >
                <div className="form-row">
                  <div className="form-left">
                    <div className="form-group">
                      <label>
                        Title
                        <span class="required" style={{ color: "red" }}>
                          {" "}
                          *{" "}
                        </span>
                      </label>
                      <input
                        type="text"
                        name="title"
                        onChange={this.handleInputChange}
                        className="form-control"
                        value={this.state.title}
                        autoComplete="off"
                      />
                      <div className="errortitle"></div>
                    </div>
                  </div>
                  <div className="form-right">
                    <div className="form-group">
                      <label>Status</label>
                      <Select
                        value={
                          selectedOption
                            ? selectedOption
                            : { value: "active", label: "Active" }
                        }
                        options={lang.common.status_option}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="title">
                  <h4>AI Screen Management</h4>
                </div>
                <div className="form-row">
                  <div className="form-left">
                    <div className="form-group">
                      <label
                        className="cursor-pointer"
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "ai_side_menu_width",
                        )}
                      >
                        Sidebar Expended size (px)
                        <span class="required" style={{ color: "red" }}>
                          {" "}
                          *{" "}
                        </span>
                        :
                        {Object.keys(aiSidebarImages).includes(
                          "ai_side_menu_width",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="ai_side_menu_width"
                        onChange={this.handleInputChange}
                        value={this.state.ai_side_menu_width}
                      />
                      <div className="errorsai_side_menu_width"></div>
                    </div>

                    <div className="form-group">
                      <label
                        className="cursor-pointer"
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "st_aisidebar_icon_width",
                        )}
                      >
                        Sidebar Icon Size (px)
                        <span class="required" style={{ color: "red" }}>
                          {" "}
                          *{" "}
                        </span>
                        :
                        {Object.keys(aiSidebarImages).includes(
                          "st_aisidebar_icon_width",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="st_aisidebar_icon_width"
                        onChange={this.handleInputChange}
                        value={this.state.st_aisidebar_icon_width}
                      />
                      <div className="errorsst_aisidebar_icon_width"></div>
                    </div>
                  </div>
                  <div className="form-right">
                    <div className="form-group">
                      <label
                        className="cursor-pointer"
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "st_aisidebar_collapsed_width",
                        )}
                      >
                        Sidebar Collapsed size (px)
                        <span class="required" style={{ color: "red" }}>
                          {" "}
                          *{" "}
                        </span>
                        :
                        {Object.keys(aiSidebarImages).includes(
                          "st_aisidebar_collapsed_width",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="st_aisidebar_collapsed_width"
                        onChange={this.handleInputChange}
                        value={this.state.st_aisidebar_collapsed_width}
                      />
                      <div className="errorsst_aisidebar_collapsed_width"></div>
                    </div>
                    <div className="form-group">
                      <label
                        className="cursor-pointer"
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "st_aisidebar_profile_icon_width",
                        )}
                      >
                        Sidebar Profile Dropdown Icon Width (px)
                        <span class="required" style={{ color: "red" }}>
                          {" "}
                          *{" "}
                        </span>
                        :
                        {Object.keys(aiSidebarImages).includes(
                          "st_aisidebar_profile_icon_width",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="st_aisidebar_profile_icon_width"
                        onChange={this.handleInputChange}
                        value={this.state.st_aisidebar_profile_icon_width}
                      />
                      <div className="errorsst_aisidebar_profile_icon_width"></div>
                    </div>
                  </div>
                </div>

                {/* Shadow Management Start */}
                <div className="title">
                  <h4>Shadow Management</h4>
                </div>
                <div className="form-row">
                  {Object.entries(this.state.shadows).map(([key, value]) => {
                    // Filter out vehicle-related shadows
                    const vehicleShadowKeys = [
                      'shadowVehicleListDefault',
                      'shadowVehicleListDefaultInset',
                      'shadowVehicleListSelection',
                      'shadowVehicleListSelectionInset',
                      'shadowTabCarouselDefault',
                      'shadowTabCarouselDefaultInset',
                      'shadowTabCarouselSelection',
                      'shadowTabCarouselSelectionInset',
                      'shadowVehicleDashboardDefault',
                      'shadowVehicleDashboardDefaultInset',
                      'shadowVehicleDashboardSelection',
                      'shadowVehicleDashboardSelectionInset',
                    ];

                    if (vehicleShadowKeys.includes(key)) {
                      return null;
                    }

                    return (
                      <div className="form-left" key={key}>
                        <div className="form-group admin-panel-btn">
                          {/* <label className='cursor-pointer' onClick={this.handleSettingsNotesPopup}>{this.labelFor(key)}: <i className='fa fa-info-circle ms-2'></i></label> */}
                          <label
                            className="cursor-pointer"
                            onClick={this.handleSettingsNotesOpenPopup.bind(
                              this,
                              key,
                            )}
                          >
                            {this.labelFor(key)}:
                            {Object.keys(shadowImages).includes(key) && (
                              <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                            )}
                          </label>
                          <input
                            value={value}
                            type="text"
                            autoComplete="off"
                            className="form-control"
                            style={{ width: "85%" }}
                            onChange={(e) =>
                              this.handleInputChangeShadows(key, e.target.value)
                            }
                          />
                          <button
                            type="button"
                            className="shadow-edit-icon"
                            onClick={() => this.confirmPopup(key)}
                            style={{
                              color: "white",
                              padding: "14px",
                              minWidth: "47px",
                              height: "48px",
                              backgroundColor: "#fff",
                              borderRadius: "0px 5px 5px 0px",
                            }}
                          >
                            <i>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#fff"
                                viewBox="32 -0.03 543.87 512.03"
                              >
                                <path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path>
                              </svg>
                            </i>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Vehicle list shadow Management */}
                <div className="title">
                  <h4>Vehicle list shadow Management</h4>
                </div>
                <div className="form-row">
                  {Object.entries(this.state.shadows).map(([key, value]) => {
                    // Show only vehicle-related shadows
                    const vehicleShadowKeys = [
                      'shadowVehicleListDefault',
                      'shadowVehicleListDefaultInset',
                      'shadowVehicleListSelection',
                      'shadowVehicleListSelectionInset',
                      'shadowTabCarouselDefault',
                      'shadowTabCarouselDefaultInset',
                      'shadowTabCarouselSelection',
                      'shadowTabCarouselSelectionInset',
                      'shadowVehicleDashboardDefault',
                      'shadowVehicleDashboardDefaultInset',
                      'shadowVehicleDashboardSelection',
                      'shadowVehicleDashboardSelectionInset',
                    ];

                    if (!vehicleShadowKeys.includes(key)) {
                      return null;
                    }

                    return (
                      <div className="form-left" key={key}>
                        <div className="form-group admin-panel-btn">
                          <label
                            className="cursor-pointer"
                            onClick={this.handleSettingsNotesOpenPopup.bind(
                              this,
                              key,
                            )}
                          >
                            {this.labelFor(key)}:
                            {Object.keys(shadowImages).includes(key) && (
                              <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                            )}
                          </label>
                          <input
                            value={value}
                            type="text"
                            autoComplete="off"
                            className="form-control"
                            style={{ width: "85%" }}
                            onChange={(e) =>
                              this.handleInputChangeShadows(key, e.target.value)
                            }
                          />
                          <button
                            type="button"
                            className="shadow-edit-icon"
                            onClick={() => this.confirmPopup(key)}
                            style={{
                              color: "white",
                              padding: "14px",
                              minWidth: "47px",
                              height: "48px",
                              backgroundColor: "#fff",
                              borderRadius: "0px 5px 5px 0px",
                            }}
                          >
                            <i>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#fff"
                                viewBox="32 -0.03 543.87 512.03"
                              >
                                <path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path>
                              </svg>
                            </i>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="title">
                  <h4>Image Size Management</h4>
                </div>

                <div className="form-row mb-0">
                  <div className="form-left">
                    <div class="form-group">
                      <h4 className="title text-start" onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "adImage",
                        )}>
                        Ads Image :{" "}
                         {Object.keys(imageSize).includes("adImage") && (

                        <i className="fa fa-info-circle ms-2 fs-6 cursor-pointer"></i>
                        )}
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-left">
                   
                      <div className="form-group">
                      <label>
                        Ads image max width:
                      </label>
                      <div className="mb-4">
                      <input
                        name="ad_imagew_unit"
                        value="%"
                        onChange={this.handleInputChange}
                        type="radio"
                        className="ms-0"
                        checked={this.state.ad_imagew_unit == "%"}
                      />
                      <span>Percentage</span>
                      <input
                        name="ad_imagew_unit"
                        value="px"
                        onChange={this.handleInputChange}
                        type="radio"
                        checked={this.state.ad_imagew_unit == "px"}
                      />
                      <span>Pixel</span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name="adsimagewidth"
                        value={this.state.adsimagewidth}
                        onChange={this.handleInputChange}
                      />
                      <div className="erroradsimagewidth"></div>
                    </div>
                    <div className="form-group">
                      <label>Ads image Radius (px):</label>
                      <input
                        type="text"
                        className="form-control"
                        name="adsimageradius"
                        value={this.state.adsimageradius}
                        onChange={this.handleInputChange}
                      />
                      <div className="erroradsimageradius"></div>
                    </div>
                  </div>
                  <div className="form-right">

                     <div className="form-group">
                      <label>
                        Ads image max height (px):
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="adsimageheight"
                        value={this.state.adsimageheight}
                        onChange={this.handleInputChange}
                      />
                      <div className="erroradsimageheight"></div>
                    </div>
                  
                  </div>
                </div>
                	<div className="form-row mb-0">
                  <div className="form-left">
                    <div class="form-group">
                      <h4 className="title text-start" onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "adPopupimage",
                        )}>
                        Ads Popup Image :{" "}
                         {Object.keys(imageSize).includes("adPopupimage") && (

                        <i className="fa fa-info-circle ms-2 fs-6 cursor-pointer"></i>
                        )}
                      </h4>
                    </div>
                  </div>
                </div>
                  <div className="form-row">
                  <div className="form-left">
					            <div className="form-group">
                      <label>
                        {/* Ads popup image max width (
                        {this.state.adp_imagew_unit}): */}
                        Ads popup image max width:
                      </label>
					  <div className="mb-4">
                  <input
                    name="adp_imagew_unit"
                    value="%"
                    onChange={this.handleInputChange}
                    type="radio"
                    className="ms-0"
                    checked={this.state.adp_imagew_unit == "%"}
                  />
                  <span>Percentage</span>
                  <input
                    name="adp_imagew_unit"
                    value="px"
                    onChange={this.handleInputChange}
                    type="radio"
                    checked={this.state.adp_imagew_unit == "px"}
                  />
                  <span>Pixel</span>
                </div>
                      <input
                        type="text"
                        className="form-control"
                        name="adspimagewidth"
                        value={this.state.adspimagewidth}
                        onChange={this.handleInputChange}
                      />
                      <div className="erroradspimagewidth"></div>
                    </div>                    

                    <div className="form-group">
                      <label>Ads popup image Radius (px):</label>
                      <input
                        type="text"
                        className="form-control"
                        name="adspimageradius"
                        value={this.state.adspimageradius}
                        onChange={this.handleInputChange}
                      />
                      <div className="erroradspimageradius"></div>
                    </div>
                  </div>
                  <div className="form-right">
                    <div className="form-group">
                      <label>
                        Ads popup image max height (px):
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="adspimageheight"
                        value={this.state.adspimageheight}
                        onChange={this.handleInputChange}
                      />
                      <div className="erroradspimageheight"></div>
                    </div>
                  </div>
                </div>

                <div className="form-row mb-0">
                  <div className="form-left">
                    <div class="form-group">
                      <h4 className="title text-start" onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "membershipimage",
                        )}>
                        Membership Image :{" "}
                        {Object.keys(imageSize).includes("membershipimage") && (
                          <i className="fa fa-info-circle ms-2 fs-6 cursor-pointer"></i>
                        )}
                      </h4>
                    </div>
                  </div>
                </div>

               

                <div className="form-row">
                  <div className="form-left">
                      <div className="form-group">
                      <label>
                        Membership image max width:
                      </label>
                      <div className="mb-4">
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          className="ms-0"
                          value="%"
                          name="mem_imagew_unit"
                          checked={this.state.mem_imagew_unit == "%"}
                        />
                        <span>Percentage</span>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          value="px"
                          name="mem_imagew_unit"
                          checked={this.state.mem_imagew_unit == "px"}
                        />
                        <span>Pixel</span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name="membershipimagewidth"
                        value={this.state.membershipimagewidth}
                        onChange={this.handleInputChange}
                      />
                      <div className="errormembershipimagewidth"></div>
                    </div>
                    <div className="form-group">
                      <label>Membership image Radius (px):</label>
                      <input
                        type="text"
                        className="form-control"
                        name="membershipimageradius"
                        value={this.state.membershipimageradius}
                        onChange={this.handleInputChange}
                      />
                      <div className="errormembershipimageradius"></div>
                    </div>
                  </div>
                  <div className="form-right">

                     <div className="form-group">
                      <label>
                        Membership image max height (px):
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="membershipimageheight"
                        value={this.state.membershipimageheight}
                        onChange={this.handleInputChange}
                      />
                      <div className="errormembershipimageheight"></div>
                    </div>
                  
                  </div>
                </div>
                 <div className="form-row mb-0">
                  <div className="form-left">
                    <div class="form-group">
                    <h4 className="title text-start"  onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "inviteimage",
                        )}>
                     
                         Invite page Image :{" "}
                      {Object.keys(imageSize).includes("inviteimage") && (

                        <i className="fa fa-info-circle ms-2 fs-6 cursor-pointer"></i>
                        )} 
                       
                      </h4>
                    </div>
                  </div>
                </div>

               

                <div className="form-row">
                  <div className="form-left">
                      <div className="form-group">
                      <label>
                        Invite page image max width:
                      </label>
                      <div className="mb-4">
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          className="ms-0"
                          value="%"
                          name="invite_imagew_unit"
                          checked={this.state.invite_imagew_unit == "%"}
                        />
                        <span>Percentage</span>
                        <input
                          onChange={this.handleInputChange}
                          type="radio"
                          value="px"
                          name="invite_imagew_unit"
                          checked={this.state.invite_imagew_unit == "px"}
                        />
                        <span>Pixel</span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name="inviteimagewidth"
                        value={this.state.inviteimagewidth}
                        onChange={this.handleInputChange}
                      />
                      <div className="errorinviteimagewidth"></div>
                    </div>
                    <div className="form-group">
                      <label>Invite page image Radius (px):</label>
                      <input
                        type="text"
                        className="form-control"
                        name="inviteimageradius"
                        value={this.state.inviteimageradius}
                        onChange={this.handleInputChange}
                      />
                      <div className="errorinviteimageradius"></div>
                    </div>
                  </div>
                  <div className="form-right">

                     <div className="form-group">
                      <label >
                        Invite page image max height (px):
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="inviteimageheight"
                        value={this.state.inviteimageheight}
                        onChange={this.handleInputChange}
                      />
                      <div className="errorinviteimageheight"></div>
                    </div>
                  
                  </div>
                </div>

                <div className="form-row mb-0">
                  <div className="form-left">
                    <div class="form-group">
                      <h4 className="fs-5">
                        Credit Card Image :{" "}
                        {/* <i className="fa fa-info-circle ms-2 fs-6 cursor-pointer"></i> */}
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-left">
                    <div className="form-group">
                      <label>
                        Credit card image max width:
                      </label>
					  <div className="mb-4">
						<input
							onChange={this.handleInputChange}
							type="radio"
							className="ms-0"
							value="%"
							name="crcard_imagew_unit"
							checked={this.state.crcard_imagew_unit == "%"}
						/>
						<span>Percentage</span>
						<input
							onChange={this.handleInputChange}
							type="radio"
							value="px"
							name="crcard_imagew_unit"
							checked={this.state.crcard_imagew_unit == "px"}
						/>
						<span>Pixel</span>
                		</div>
                      <input
                        type="text"
                        className="form-control"
                        name="crcardimagewidth"
                        value={this.state.crcardimagewidth}
                        onChange={this.handleInputChange}
                      />
                      <div className="errocrcardimagewidth"></div>
                    </div>
                    <div className="form-group">
                      <label>Credit card image Radius (px):</label>
                      <input
                        type="text"
                        className="form-control"
                        name="crcardimageradius"
                        value={this.state.crcardimageradius}
                        onChange={this.handleInputChange}
                      />
                      <div className="errorcrcardimageradius"></div>
                    </div>
                  </div>
                  <div className="form-right">
					<div className="form-group">
                      <label>
                         Credit card image max height (px): (up to 150px)
                      </label>
					
                      <input
                        type="text"
                        className="form-control"
                        name="crcardimageheight"
                        value={this.state.crcardimageheight}
                        onChange={this.handleInputChange}
                      />
                      <div className="errorcrcardimageheight"></div>
                    </div>
                    
                  </div>
                </div>

                <div className="form-row mb-0">
                  <div className="form-left">
                    <div class="form-group">
                      <h4 className="fs-5">
                        Insurance Image :{" "}
                        {/* <i className="fa fa-info-circle ms-2 fs-6 cursor-pointer"></i> */}
                      </h4>
                    </div>
                  </div>
                </div>
                 <div className="form-row">
                  <div className="form-left">
                    <div className="form-group">
                      <label>
                       Insurance image max width:
                      </label>
					  <div className="mb-4">
						<input
							onChange={this.handleInputChange}
							type="radio"
							className="ms-0"
							value="%"
							name="ins_imagew_unit"
							checked={this.state.ins_imagew_unit == "%"}
						/>
						<span>Percentage</span>
						<input
							onChange={this.handleInputChange}
							type="radio"
							value="px"
							name="ins_imagew_unit"
							checked={this.state.ins_imagew_unit == "px"}
						/>
						<span>Pixel</span>
                		</div>
                      <input
                        type="text"
                        className="form-control"
                        name="insimagewidth"
                        value={this.state.insimagewidth}
                        onChange={this.handleInputChange}
                      />
                      <div className="errorinsimagewidth"></div>
                    </div>
                    <div className="form-group">
                      <label>Insurance image Radius (px):</label>
                      <input
                        type="text"
                        className="form-control"
                        name="insimageradius"
                        value={this.state.insimageradius}
                        onChange={this.handleInputChange}
                      />
                      <div className="errorinsimageradius"></div>
                    </div>
                  </div>
                  <div className="form-right">
					<div className="form-group">
                      <label>
                        Insurance image max height (px): (up to 150px)
                      </label>
					
                      <input
                        type="text"
                        className="form-control"
                        name="insimageheight"
                        value={this.state.insimageheight}
                        onChange={this.handleInputChange}
                      />
                      <div className="errorinsimageheight"></div>
                    </div>
                    
                  </div>
                </div>




                <div className="title">
                  <h4>Radius Management</h4>
                </div>
                <div className="form-row">
                  <div className="form-left">
                    <div className="form-group">
                      <label
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "pluginRadius",
                        )}
                      >
                        Plugin Radius (px):
                        {Object.keys(radiusImages).includes("pluginRadius") && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="pluginRadius"
                        onChange={this.handleInputChange}
                        value={this.state.pluginRadius}
                      />
                      <div className="errorpluginRadius"></div>
                    </div>
                    <div className="form-group">
                      <label
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "inputRadius",
                        )}
                      >
                        Input Box Radius (px):
                        {Object.keys(radiusImages).includes("inputRadius") && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="inputRadius"
                        onChange={this.handleInputChange}
                        value={this.state.inputRadius}
                      />
                      <div className="errorinputRadius"></div>
                    </div>
                    <div className="form-group">
                      <label
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "dashboardGridRadius",
                        )}
                      >
                        Dashboard Grid Radius (px):
                        {Object.keys(radiusImages).includes(
                          "dashboardGridRadius",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="dashboardGridRadius"
                        onChange={this.handleInputChange}
                        value={this.state.dashboardGridRadius}
                      />
                      <div className="errordashboardGridRadius"></div>
                    </div>
                    <div className="form-group">
                      <label
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "listRowRadius",
                        )}
                      >
                        List Row Radius (px):
                        {Object.keys(radiusImages).includes(
                          "listRowRadius",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="listRowRadius"
                        onChange={this.handleInputChange}
                        value={this.state.listRowRadius}
                      />
                      <div className="errorlistRowRadius"></div>
                    </div>
                    <div className="form-group">
                      <label
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "formGroupRadius",
                        )}
                      >
                        Form Group Radius (px):
                        {Object.keys(radiusImages).includes(
                          "formGroupRadius",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="formGroupRadius"
                        onChange={this.handleInputChange}
                        value={this.state.formGroupRadius}
                      />
                      <div className="errorformGroupRadius"></div>
                    </div>
                    <div className="form-group">
                      <label
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "topPopupRadius",
                        )}
                      >
                        Top Popup Radius (px):
                        {Object.keys(radiusImages).includes(
                          "topPopupRadius",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="topPopupRadius"
                        onChange={this.handleInputChange}
                        value={this.state.topPopupRadius}
                      />
                      <div className="errortopPopupRadius"></div>
                    </div>
                  </div>
                  <div className="form-right">
                    <div className="form-group">
                      <label
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "dropdownRadius",
                        )}
                      >
                        Dropdown Menu Radius (Bell notification, Group menu in
                        listing screen, Message box, Address dropdown) (px):
                        {Object.keys(radiusImages).includes(
                          "dropdownRadius",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="dropdownRadius"
                        onChange={this.handleInputChange}
                        value={this.state.dropdownRadius}
                      />
                      <div className="errordropdownRadius"></div>
                    </div>
                    <div className="form-group">
                      <label
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "textareaRadius",
                        )}
                      >
                        Textarea Radius (px):
                        {Object.keys(radiusImages).includes(
                          "textareaRadius",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="textareaRadius"
                        onChange={this.handleInputChange}
                        value={this.state.textareaRadius}
                      />
                      <div className="errortextareaRadius"></div>
                    </div>
                    <div className="form-group">
                      <label
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "dashboardListRadius",
                        )}
                      >
                        Dashboard List Radius (px):
                        {Object.keys(radiusImages).includes(
                          "dashboardListRadius",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="dashboardListRadius"
                        onChange={this.handleInputChange}
                        value={this.state.dashboardListRadius}
                      />
                      <div className="errordashboardListRadius"></div>
                    </div>
                    <div className="form-group">
                      <label
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "mapPopupRadius",
                        )}
                      >
                        Map Popup Radius (px):
                        {Object.keys(radiusImages).includes(
                          "mapPopupRadius",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="mapPopupRadius"
                        onChange={this.handleInputChange}
                        value={this.state.mapPopupRadius}
                      />
                      <div className="errormapPopupRadius"></div>
                    </div>
                    <div className="form-group">
                      <label
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "mainAITextareaRadius",
                        )}
                      >
                        AI Screen Textarea Radius (px):
                        {Object.keys(radiusImages).includes(
                          "mainAITextareaRadius",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="mainAITextareaRadius"
                        onChange={this.handleInputChange}
                        value={this.state.mainAITextareaRadius}
                      />
                      <div className="errormainAITextareaRadius"></div>
                    </div>
                  </div>
                </div>

                {/* Settings notes popup */}
                <div
                  className={`${this.state.settingsNotesPopup && "active"} popup-sec`}
                >
                  <div className="popup-sec-in">
                    <span
                      onClick={this.handleSettingsNotesClosePopup}
                      className="popup-close position-absolute cursor-pointer"
                    >
                      X
                    </span>
                    {/* <Slider className='settings-notes-slider' {...settings}>
									<img src='http://localhost:3000/assets/setting-notes/shadow/shadow-open-button.png' /> 	
									<img src='http://localhost:3000/assets/setting-notes/shadow/shadow-plugin.png' /> 	
								</Slider> */}
                    <Slider
                      className="settings-notes-slider"
                      key={this.state.settingsNotesPopup ? "open" : "closed"}
                      {...settings}
                    >
                      {/* Shadow images */}
                      {Object.keys(shadowImages).map(
                        (shadowKey) =>
                          this.state.infoSliderName === shadowKey &&
                          shadowImages[this.state.infoSliderName].map(
                            (img, i) => (
                              <div key={`${shadowKey}-${i}`}>
                                <h4 className="settings-notes-slide-title">
                                  {img.title}
                                </h4>
                                <img src={img.src} alt={img.title} />
                              </div>
                            ),
                          ),
                      )}

                      {/* AI Sidebar Images */}
                      {Object.keys(aiSidebarImages).map(
                        (sidebarKey) =>
                          this.state.infoSliderName === sidebarKey &&
                          aiSidebarImages[sidebarKey].map((img, i) => (
                            <div key={`${sidebarKey}-${i}`}>
                              <h4 className="settings-notes-slide-title">
                                {img.title}
                              </h4>
                              <img src={img.src} alt={img.title} />
                            </div>
                          )),
                      )}

                      {/* Radius images */}
                      {Object.keys(radiusImages).map(
                        (radiusKey) =>
                          this.state.infoSliderName === radiusKey &&
                          radiusImages[radiusKey].map((img, i) => (
                            <div key={`${radiusKey}-${i}`}>
                              <h4 className="settings-notes-slide-title">
                                {img.title}
                              </h4>
                              <img src={img.src} alt={img.title} />
                            </div>
                          )),
                      )}

                      {Object.keys(imageSize).map(
                        (radiusKey) =>
                          this.state.infoSliderName === radiusKey &&
                          imageSize[radiusKey].map((img, i) => (
                            <div key={`${radiusKey}-${i}`}>
                              <h4 className="settings-notes-slide-title">
                                {img.title}
                              </h4>
                              <img src={img.src} alt={img.title} />
                            </div>
                          )),
                      )}

                      {/* Font Management images */}
                      {Object.keys(fontManagementImages).map(
                        (radiusKey) =>
                          this.state.infoSliderName === radiusKey &&
                          fontManagementImages[radiusKey].map((img, i) => (
                            <div key={`${radiusKey}-${i}`}>
                              <h4 className="settings-notes-slide-title">
                                {img.title}
                              </h4>
                              <img src={img.src} alt={img.title} />
                            </div>
                          )),
                      )}

                      {/* Inside Font Management images */}
                      {Object.keys(insidefontManagementImages).map(
                        (radiusKey) =>
                          this.state.infoSliderName === radiusKey &&
                          insidefontManagementImages[radiusKey].map(
                            (img, i) => (
                              <div key={`${radiusKey}-${i}`}>
                                <h4 className="settings-notes-slide-title">
                                  {img.title}
                                </h4>
                                <img src={img.src} alt={img.title} />
                              </div>
                            ),
                          ),
                      )}
                    </Slider>
                  </div>
                </div>

                <div className="form-row">
                  <div className="input-popup-action">
                    <a
                      className="popup-close position-absolute cursor-pointer"
                      onClick={this.handleCancel}
                    >
                      X
                    </a>
                    <div className="title">
                      <h4>{this.labelFor(this.state.activeShadowType)}</h4>
                    </div>

                    <div className="shadow-picker-container d-flex w-100 justify-content-between">
                      <ShadowPicker
                        value={
                          this.state.shadows[this.state.activeShadowType] || ""
                        }
                        onChange={(value) => this.handleShadowChange(value)}
                        className="shadow-picker"
                      />

                      <div
                        className="shadow-box"
                        style={{
                          boxShadow:
                            this.state.shadows[this.state.activeShadowType] ||
                            "none",
                        }}
                      ></div>
                    </div>
                    <div className="d-flex w-100 justify-content-end gap-2 mt-5">
                      <a className="primary-btn" onClick={this.handleSubmit}>
                        Save
                      </a>
                    </div>
                  </div>
                </div>
                {/* Shadow Management End */}

                {/* Font Management End */}
                <div className="title">
                  <h4>Font Management</h4>
                </div>
                <div className="form-row">
                  <div className="form-left">
                    <div className="form-group">
                      <label
                        onClick={this.handleSettingsNotesOpenPopup.bind(
                          this,
                          "line_height",
                        )}
                      >
                        Line Height :{" "}
                        {Object.keys(fontManagementImages).includes(
                          "line_height",
                        ) && (
                          <i className="fa fa-info-circle ms-2 cursor-pointer fs-6"></i>
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="line_height"
                        onChange={this.handleInputChange}
                        value={this.state.line_height}
                      />
                      <div className="errorline_height"></div>
                    </div>
                  </div>
                </div>

                {this.addMoreFunc()}
                {/* Font Management End */}

                {/* <div className="btn-group export">							
							<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&  <span className="load-data"></span> }Submit
							</button>
						</div> */}
                <div className="btn-group export">
                  <button
                    className="btn btn_orange btn_minwid login_submit animate-btn2"
                    //type="submit"
                    type="button"
                    //onClick={() => this.setState({ formAction: "clone", title : this.state.title+' Copy' })}
                    onClick={() => this.confirmThemePopup(this.state.title)}
                    disabled={this.state.LoadingCloneBtn}
                    style={{ marginRight: "10px" }}
                  >
                    {this.state.LoadingCloneBtn && (
                      <span className="load-data"></span>
                    )}{" "}
                    Save as New
                  </button>

                  <button
                    className="btn btn_orange btn_minwid login_submit animate-btn2"
                    type="submit"
                    onClick={() => this.setState({ formAction: "edit" })}
                    disabled={this.state.Loading}
                  >
                    {this.state.Loading && <span className="load-data"></span>}{" "}
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Edit);
